import React from 'react'
import Layout from '../../Layout/Layout'

const National_generative_AI = () => {
  return (
     <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>National Generative AI Policy for Inclusive Innovation (Nigeria 2025–2030)</h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The National Generative AI Policy for Inclusive Innovation 
                        (Nigeria 2025–2030) is a foundational national policy framework developed to
                         guide the responsible adoption of Generative AI (GenAI) across Nigeria . This
                          strategic document is intended to ensure that the adoption of GenAI within 
                          public services and the vibrant Nigerian startup ecosystem is ethical, safe,
                           and highly relevant to local needs. By providing a clear regulatory and 
                           developmental roadmap, the policy aims to establish a trusted and sustainable
                            environment for AI growth.
</p>

                <p className='light'>The primary objective of this groundbreaking policy is to strategically
                     position Nigeria as the regional leader in AI governance within the African continent.
                      By proactively establishing standards and frameworks for the technology, the policy 
                      sets a precedent for responsible innovation. This authoritative guidance is essential
                       for ensuring that AI development and deployment prioritize social benefit while
                        maintaining public trust and national security.</p>
               </div>

                <div className='uk-width-1-2@s'>
                <p className='light'>Furthermore, the policy's contribution extends directly to shaping
                     Nigeria's national preparedness to fully exploit the vast economic potential of the 
                     technology. The framework is designed to help Nigeria capitalize on the estimated 
                     $234 billion Africa AI opportunity, ensuring that economic benefits are inclusive 
                     and widespread. It provides the necessary structure to foster a competitive 
                     ecosystem where local startups can build and scale GenAI solutions.</p>

                <p className='light'>Ultimately, the National Generative AI Policy serves as a vital 
                    blueprint for inclusive innovation, ensuring that the transformative power of 
                    AI is harnessed for all citizens. It outlines the pathways for talent development,
                     ethical data use, and cross-sectoral application, transforming Nigeria’s digital
                      economy. The policy marks a commitment to a technology-driven future where
                       Nigeria is a leading player in the global AI landscape, driving socio-economic progress. </p>

                        <p className='light'><span className='uk-text-bold'>Contribution: </span>Establishing Nigeria as a regional AI governance 
                        leader; shaping national preparedness for the $234B Africa AI opportunity.</p>
                         <p className='light'>DOI: https://doi.org/10.5281/zenodo.16850191</p>
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default National_generative_AI